import { useState } from "react";

export default function FAQSection() {
    const faqs = [
        {
            question: "Who should attend this NEET counselling seminar?",
            answer:
                "Students preparing for NEET counselling, recent qualifiers, and parents who want clear guidance on admission steps can all benefit from this session.",
        },
        {
            question: "Will this cover both MCC and State counselling?",
            answer:
                "Yes. The seminar explains AIQ/MCC counselling and state counselling flow, including key rounds, timelines, and common mistakes to avoid.",
        },
        {
            question: "Do I need to bring any documents for the seminar?",
            answer:
                "No physical documents are needed for attending. We will share a practical checklist of the documents you should keep ready for actual counselling.",
        },
        {
            question: "Can parents join this session?",
            answer:
                "Absolutely. Parents are encouraged to join so they can understand counselling decisions, timelines, and admission planning with confidence.",
        },
        {
            question: "Will there be a Q&A session with experts?",
            answer:
                "Yes, a dedicated Q&A segment is included where participants can ask counselling-related questions and get expert direction.",
        },

        // 🔥 UPDATED SEMINAR FAQs

        {
            question: "Is this seminar free or paid?",
            answer:
                "This is a completely free seminar. You only need to register your seat in advance as limited seats are available.",
        },
        {
            question: "What is the duration of the seminar?",
            answer:
                "The seminar will be approximately 2 hours long, including expert sessions and a Q&A discussion.",
        },
        {
            question: "Where is the seminar being conducted?",
            answer:
                "The seminar will be conducted at a premium offline venue. Exact location and Google Maps link will be shared after registration.",
        },
        {
            question: "What will I gain from attending this seminar?",
            answer:
                "You will get complete clarity on counselling strategy, college selection, rank vs college mapping, and expert guidance to avoid costly mistakes.",
        },
        {
            question: "Will I get guidance after the seminar?",
            answer:
                "Yes. After the seminar, you will have access to further guidance options including 1-to-1 counselling support and expert assistance.",
        },
    ];
    const [activeFAQ, setActiveFAQ] = useState(null);

    const toggleFAQ = (index) => {
        setActiveFAQ(activeFAQ === index ? null : index);
    };

    return (
        <section className="w-full max-w-7xl mx-auto mt-14 mb-16 sm:mb-0">
            <h2
                className="text-2xl sm:text-3xl font-bold text-center capitalize"
                style={{ color: "#140342" }}
            >
                Frequently asked <span className="text-[#ff9245]">questions</span>
            </h2>
            <div className="mt-8 space-y-4 ml-6 mr-6">
                {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`p-4 border rounded-lg shadow-md ${activeFAQ === index ? "bg-gray-50" : ""
                            }`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className="flex justify-between items-center cursor-pointer">
                            <h3
                                className="text-lg font-semibold"
                                style={{ color: "#140342" }}
                            >
                                {faq.question}
                            </h3>
                            <span>{activeFAQ === index ? "-" : "+"}</span>
                        </div>
                        <div
                            className={`mt-2 text-gray-600 text-left text-sm leading-6 ${activeFAQ === index ? "block" : "hidden"
                                }`}
                        >
                            {faq.answer}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}